"use client";

import type { PipelineCandidate } from "@/lib/api/types";
import { Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip";
import { EmptyCell } from "@/features/candidate";
import { formatExactDateTime, formatStageDuration } from "../utils";

/**
 * "In Stage" cell — how long the candidate has been in their current stage,
 * shown as a compact duration (e.g. "3d") with the exact entry time on hover.
 * Sourced from `stage_entered_at`, which resets on every stage move.
 */
export function InStageCell({ candidate }: { candidate: PipelineCandidate }) {
  if (!candidate.stage_entered_at) {
    return <EmptyCell />;
  }
  const exact = formatExactDateTime(candidate.stage_entered_at);
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="cursor-default whitespace-nowrap text-sm text-muted-foreground">
          {formatStageDuration(candidate.stage_entered_at)}
        </span>
      </TooltipTrigger>
      <TooltipContent side="top">Entered stage {exact}</TooltipContent>
    </Tooltip>
  );
}
